import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import { contentfulViews, components } from '@glowforge/ui-common';


import './features-display.less';

const { Image } = contentfulViews;
const { Button, Markdown, HorizontalScroll } = components;

/**
 * FeaturesDisplay component. Ported from legacy homepage.
 * Shows a 'hero' card above a grid of buttons on desktop.
 * Shows a HorizontalScroll list of the same cards on mobile.
 *
 * @param title -
 * @param seeMoreText -
 * @param features - An array of Objects of:
 *    {
 *      title: String for object title
 *      text: String for object description
 *      media: Object representing Contentful Media type, passed to Image
 *    }
 */
class FeaturesDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
    };
  }

  // Thunked function. Binds 'index' to specific buttons
  // by returning function bound to index passed.
  onClick = index => () => {
    this.setState({ selectedIndex: index });
  }

  render() {
    const {
      features,
      seeMoreText,
      title: displayTitle,
    } = this.props;
    const { selectedIndex } = this.state;

    // Button Grid
    // If selected, then that button is disabled.
    const buttons = _.map(features, ({ title: buttonTitle }, index) => (
      <Button
        key={buttonTitle}
        type='secondary'
        disabled={index === selectedIndex}
        onClick={this.onClick(index)}>
        {buttonTitle}
      </Button>
    ));

    // Cards array
    // Used on desktop to show each card based on index.
    // Used on mobile to show HorizontalList of cards
    const cards = _.map(features, ({
      title,
      media,
      text,
    }) => (
      <div className='featureCard' key={title}>
        <div className='image'><Image className='src' media={media} /></div>
        <div className='content'>
          <h3 className='title'>{title}</h3>
          <Markdown source={text} />
        </div>
      </div>
    ));

    // The 'hero' card to display
    const selectedFeature = cards[selectedIndex];
    return (
      <div className='FeaturesDisplay'>
        <div className='content'>
          <h2 className='displayTitle'>{displayTitle}</h2>
          <div className='selectedFeature'>{selectedFeature}</div>
          <div className='featuresGrid'>{buttons}</div>
          <div className='featureCards'>
            <HorizontalScroll>{cards}</HorizontalScroll>
            <span className='seeMore'>{seeMoreText}</span>
          </div>
        </div>
      </div>
    );
  }
}

FeaturesDisplay.propTypes = {
  title: PropTypes.string,
  seeMoreText: PropTypes.node,
  features: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    media: PropTypes.shape({}),
  })),
};

FeaturesDisplay.defaultProps = {
  title: null,
  seeMoreText: null,
  features: [],
};

export default FeaturesDisplay;



// WEBPACK FOOTER //
// ./app/common/components/features-display/features-display.jsx